import { formatCidDescription, normalizeCidCodes } from '../cid-descriptions';

export function AnalysisCidList({
  codes,
  descriptions,
}: {
  codes: string[];
  descriptions?: Record<string, string | null>;
}) {
  const normalized = normalizeCidCodes(codes);
  if (!normalized.length) return <span>—</span>;
  return (
    <span className='flex flex-col gap-1 text-left'>
      {normalized.map(code => (
        <span key={code} className='break-words'>
          {formatCidDescription(code, descriptions?.[code])}
        </span>
      ))}
    </span>
  );
}
